import '@babel/polyfill'
import 'url-search-params-polyfill';
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

import App from './App.vue'
import router from './router'
import FullCalendar from "vue-full-calendar";

import "fullcalendar/dist/fullcalendar.min.css";

import 'expose-loader?$!expose-loader?jQuery!jquery'

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import VueDaumPostcode from "vue-daum-postcode"
import VModal from 'vue-js-modal'

import VueCarousel from 'vue-carousel';
import vueMoment from 'vue-moment'
import moment from "moment";
import VueCookies from 'vue-cookies'
import Paginate from 'vuejs-paginate'

//import IMP from 'vue-iamport'
import VueGtag from 'vue-gtag'

import VueMoment from 'vue-moment'

Vue.use(VueCookies)
Vue.$cookies.config('7d')
Vue.use(VModal, { dynamic: true, dialog: true })
Vue.use(VueDaumPostcode)
Vue.use(VueAxios, axios)
Vue.use(FullCalendar)
Vue.config.productionTip = false
Vue.router = router
Vue.component('paginate', Paginate)
Vue.use(require('@websanova/vue-auth'), {
  registerData: {url: process.env.VUE_APP_AUTH_API_URL + '/join', redirect: '/auth/email', method: 'POST'},
  refreshData: {url: process.env.VUE_APP_AUTH_API_URL + '/refresh', method: 'GET', enabled: false, interval: 0},
  loginData: {url: process.env.VUE_APP_AUTH_API_URL + '/login', method: 'POST', redirect: '/', fetchUser: true},
  fetchData: {url: process.env.VUE_APP_AUTH_API_URL + '/member', method: 'GET', enabled: true, success: function (res) {
      //let token = Vue.auth.token();
      //res.data.roles = ['MEMBER', 'ADMIN'];
      Vue.auth.user(res.data);
    }},
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  rolesVar: 'roleNames',
})
Vue.use(VueMoment)

axios.interceptors.response.use(
    response => {
        return response
    },
    error => {
        if (error.response && error.response.status === 401) {
            console.log('error')
            Vue.auth.options.logoutProcess.call(Vue.auth, {}, {})
        }
        return Promise.reject(error)
    })
Vue.use(VueCarousel);
//let token = Vue.auth.token();
//axios.defaults.headers.common['Authorization'] = `Bearer ${token}`

//Vue.use(IMP, 'imp30854117') //아임포트 회원가입 후 발급된 가맹점 고유 코드를 사용해주세요.
//Vue.IMP().load()

moment.locale('ko');

Vue.use(vueMoment, { moment });

Vue.use(VueGtag, {
    config: {
        id: 'G-02NSTHMEW7'  // Google Analytics의 Tracking ID를 넣어준다
    }
});

new Vue({
    router,
   // store,
    render: h => h(App)
}).$mount('#app')
